/* Baaz Baadal Blue Analog — campaign page script (Shopify build).
 * Plain JavaScript, no frameworks. Reads window.BB_PDP / window.BB_LOOK / window.BB_RC /
 * window.BB_FAQ_COUNT injected by the page sections; falls back to demo defaults otherwise. */
(function () {
  'use strict';

  var AC = { pill: 'linear-gradient(180deg,#fffbea 0%,#fbefbd 48%,#f4dd85 52%,#f8e9a6 100%)', border: '#a5852c', solid: '#f4dd85' };
  var GLOSSY = 'linear-gradient(180deg,#ffffff 0%,#e7ebf2 48%,#d0d0d0 52%,#e3e8f0 100%)';
  var PAD = 'linear-gradient(180deg,#ffffff,#e3e3e3)';

  var PDP = window.BB_PDP || {};
  var RCDATA = window.BB_RC || null;
  var SIZES = ['UK 6', 'UK 7', 'UK 8', 'UK 9', 'UK 10', 'UK 11', 'UK 12'];
  var IMGS = [
    { src: 'assets/detail-shoe-denim.webp', fit: 'contain', label: 'Side' },
    { src: 'assets/gallery-onfoot.webp', fit: 'cover', label: 'On foot' },
    { src: 'assets/gallery-top.webp', fit: 'contain', label: 'Top' },
    { src: 'assets/gallery-back.webp', fit: 'contain', label: 'Back' },
    { src: 'assets/gallery-heel.webp', fit: 'cover', label: 'Heel' }
  ];
  var DETAILS_BASE = [
    { t: 'Denim upper', b: 'Washed denim panels across the upper, with contrast stitching.', x: 39, y: 40 },
    { t: 'The Baaz trail', b: 'The signature trail runs the full length of the shoe.', x: 49, y: 50 },
    { t: 'Speckled laces', b: 'Circular speckled laces through metal eyelets.', x: 54, y: 41 },
    { t: 'Rubber sole', b: 'Natural rubber for grip. Memory foam and bamboo lycra lining inside.', x: 49, y: 61 }
  ];
  var DETAILS = (window.BB_LOOK && window.BB_LOOK.length ? window.BB_LOOK : DETAILS_BASE).map(function (d, k) {
    return { n: (k + 1) < 10 ? '0' + (k + 1) : String(k + 1), t: d.t, b: d.b, x: d.x, y: d.y };
  });
  var FAQ_COUNT = (window.BB_FAQ_COUNT | 0) || 5;
  var RC = (RCDATA && RCDATA.years && RCDATA.years.length) ? RCDATA : { years: ['2000', '2003', '2026'], stamps: ["'00", "'03", "'26"], labels: ['the early 2000s', 'mtv \u00b7 indipop \u00b7 bollywood', 'today'] };

  function pad2(n) { return String(n).padStart(2, '0'); }
  function prodOf(g) { return PDP[g] || null; }
  function sizesOf(g) {
    var p = prodOf(g), a = (p && p.sizes) || [];
    if (a.length) return a;
    return SIZES.map(function (t) { return { id: null, title: t, available: true }; });
  }
  function imgsOf(g) {
    var p = prodOf(g), a = (p && p.images) || [];
    return a.length ? a : IMGS;
  }
  function maxImgs() { return Math.max(imgsOf('Men').length, imgsOf('Women').length, 5); }
  function maxSizes() { return Math.max(sizesOf('Men').length, sizesOf('Women').length, 1); }
  function fallbackSrc(kind) {
    var p = prodOf('Men'), a = (p && p.images) || [];
    if (!a.length) { p = prodOf('Women'); a = (p && p.images) || []; }
    if (!a.length) return null;
    return a[0].src;
  }

  // Every value on the page that changes with interaction or time
  function compute(s) {
    var c = s.pd, i = s.dIdx, f = DETAILS[i], z = i >= 0, tp = s.tape;
    var sel = function (k) { return k === s.rc; };
    var g = c.g, sizes = sizesOf(g), imgs = imgsOf(g);
    var ci = Math.min(c.i, imgs.length - 1), cur = imgs[ci];
    var sv = c.sz >= 0 ? sizes[Math.min(c.sz, sizes.length - 1)] : null;
    var pc = prodOf(g) || {};
    var title = pc.title || 'GULLY NUMBER 001 \u2013 Baaz Baadal Blue Analog';
    var price = pc.priceDisplay || 'INR 5990.00';
    var desc = pc.description || 'Denim panels, a metallic stud trail and yellow laces. One mystery cassette in every box, filled with random videos. Play it in our Delhi or Bangalore store.';
    var genderBtns = ['Men', 'Women'].map(function (gg) {
      return c.g === gg ? { bg: AC.pill, border: '1px solid ' + AC.border, shadow: 'inset 0 1px 0 rgba(255,255,255,.9)' } : { bg: 'transparent', border: '1px solid transparent', shadow: 'none' };
    });
    var sizeBtns = [];
    for (var k = 0; k < maxSizes(); k++) {
      var act = (k === c.sz && c.sz >= 0);
      sizeBtns.push(act
        ? { bg: AC.solid, fg: '#081324', shadow: 'inset 0 2px 3px rgba(0,0,0,.25)' }
        : { bg: PAD, fg: '#081324', shadow: 'inset 0 1px 0 #fff' });
    }
    var thumbBtns = [];
    for (var tK = 0; tK < maxImgs(); tK++) {
      thumbBtns.push({ ring: tK === ci ? '0 0 0 3px #5572a1, 0 2px 4px rgba(0,0,0,.2)' : '0 2px 4px rgba(0,0,0,.15)' });
    }
    return {
      cartCount: String(c.n),
      timecode: '0:' + pad2(Math.floor(s.tc / 60) % 60) + ':' + pad2(s.tc % 60),
      recOpacity: s.tc % 2 ? '1' : '0.2',
      stickyY: s.sticky ? '0' : '110%',
      pdLive: !!prodOf(g),
      pdFlash: !!c.flash,
      pdCtaText: !prodOf(g) ? 'Coming soon'
        : c.flash ? 'Added \u00b7 ' + g + ' ' + (sv ? sv.title : '')
        : (sv ? 'Add to cart \u00b7 ' + g + ' ' + sv.title : 'Select a size'),
      pdTitle: title, pdPrice: price, pdDesc: desc, pdLine: title + ' \u00b7 ' + price,
      pdSetM: g === 'Men', pdSetW: g === 'Women', pdErr: c.err,
      pdFile: cur.label, pdImg: cur.src, pdFit: cur.fit,
      pdFrame: 'FRAME ' + pad2(ci + 1) + ' / ' + pad2(imgs.length),
      pdCta: !prodOf(g) ? 'Coming soon'
        : c.flash ? '\u2713 Added \u00b7 ' + g + ' ' + (sv ? sv.title : '')
        : (sv ? 'Add to cart \u00b7 ' + g + ' ' + sv.title : 'Select a size'),
      pdThumbs: thumbBtns,
      pdGenders: genderBtns,
      pdSizes: sizeBtns,
      dOrigin: z ? f.x + '% ' + f.y + '%' : '50% 50%',
      dTransform: z ? 'translate(' + (50 - f.x) + '%,' + (50 - f.y) + '%) scale(2)' : 'translate(0,0) scale(1)',
      dFocusOp: z ? '1' : '0', dFocusScale: z ? '1' : '1.4',
      dZoomLabel: z ? 'ZOOM 2.0\u00d7' : 'WIDE', dCount: z ? f.n + ' / ' + pad2(DETAILS.length) : '00 / ' + pad2(DETAILS.length),
      dNum: z ? f.n : '00', dTotal: pad2(DETAILS.length),
      dTitle: z ? f.t : 'Baaz Baadal Blue Analog',
      dBody: z ? f.b : 'Tap a point on the shoe to look closer.',
      dTabs: DETAILS.map(function (_, k) { return { bg: k === i ? AC.pill : GLOSSY }; }),
      dSpots: DETAILS.map(function (_, k) {
        return {
          tr: 'scale(' + (z ? .5 : 1) + ')', op: z && k !== i ? '0' : '1',
          bg: k === i ? 'linear-gradient(180deg,#e1e9f5,#7f99c2)' : GLOSSY
        };
      }),
      rcYear: RC.years[s.rc] || RC.years[0],
      rcModeText: ['REC', 'PLAY', 'REWIND'][s.rc], rcModePlay: s.rc === 1, rcModeRew: s.rc === 2, rcStamp: RC.stamps[s.rc] || "'00",
      rcLabel: RC.labels[s.rc] || RC.labels[0],
      rcShift: s.mob ? (-s.rc * 100) + '%' : '0',
      rcOp0: s.mob || s.rc === 0 ? '1' : '.3', rcOp1: s.mob || s.rc === 1 ? '1' : '.3', rcOp2: s.mob || s.rc === 2 ? '1' : '.3',
      rcPhotos: [0, 1, 2].map(function (k) { return { op: sel(k) ? '1' : '0', sc: sel(k) ? '1' : '1.06' }; }),
      rcRows: [0, 1, 2].map(function (k) { return { bg: sel(k) ? AC.pill : 'transparent', border: sel(k) ? '1px solid ' + AC.border : '1px solid transparent' }; }),
      rcTabs: [0, 1, 2].map(function (k) { return { bg: sel(k) ? AC.pill : 'transparent', border: sel(k) ? '1px solid ' + AC.border : '1px solid transparent' }; }),
      rcBars: [0, 1, 2].map(function (k) { return { bg: k <= s.rc ? AC.solid : '#e8e8e8' }; }),
      transport: ['x', 'play', 'stop', 'loading'].map(function (k) {
        var on = (k === 'play' && (tp === 'glitch' || tp === 'done')) || (k === 'loading' && tp === 'loading') || (k === 'stop' && tp === 'idle');
        return { bg: on ? AC.pill : GLOSSY };
      }),
      screenMode: tp === 'idle' ? 'STBY' : tp === 'loading' ? 'LOAD' : 'PLAY',
      tapeState: tp, playIdle: tp === 'idle', playDone: tp === 'done',
      playText: tp === 'idle' ? 'Preview your tape' : (tp === 'done' ? 'Play the preview again' : 'Cueing up\u2026'),
      faqs: Array.from({ length: FAQ_COUNT }, function (_, k) { return { open: s.faq === k, sign: s.faq === k ? '\u2013' : '+' }; })
    };
  }

  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqMob = window.matchMedia('(max-width: 900px)');
  var initEl = document.querySelector('[data-bb-init-cart]');
  var initCount = initEl ? parseInt(initEl.getAttribute('data-bb-init-cart'), 10) : 0;
  var initGender = PDP.Men ? 'Men' : (PDP.Women ? 'Women' : 'Men');
  var state = { pd: { g: initGender, sz: -1, zId: null, err: false, n: isNaN(initCount) ? 0 : initCount, i: 0, flash: false }, tape: 'idle', mob: mqMob.matches, rc: 0, dIdx: -1, dHov: false, tc: 0, faq: 0, sticky: false };
  // Fit the hero to the viewport below the sticky brand header
  var headroom = function () {
    var hg = document.querySelector('.shopify-section-group-header-group');
    if (hg) document.documentElement.style.setProperty('--bb-headroom', hg.offsetHeight + 'px');
  };
  headroom();
  window.addEventListener('load', headroom);
  var dPause = 0, w1, w2, lastBarKey = null, lastThumbIdx = 0;

  function get(o, p) { return p.split('.').reduce(function (a, k) { return a == null ? undefined : a[k]; }, o); }
  function all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  // Bindings in the HTML: data-s = dynamic inline styles, data-t = dynamic text, data-if = show/hide
  var styleBinds = all('[data-s]').map(function (el) { return { el: el, map: JSON.parse(el.getAttribute('data-s')), last: {} }; });
  var textBinds = all('[data-t]').map(function (el) { return { el: el, p: el.getAttribute('data-t') }; });
  var ifBinds = all('[data-if]').map(function (el) { return { el: el, p: el.getAttribute('data-if') }; });
  var bars = all('[data-bar]');

  // Images not picked in the editor fall back to the assigned products' shots
  all('img[data-bb-fallback]').forEach(function (el) {
    var src = fallbackSrc(el.getAttribute('data-bb-fallback'));
    if (src && !el.getAttribute('src')) { el.src = src; el.removeAttribute('data-bb-fallback'); }
  });
  // Look closer: zoom stage + detail tabs follow the Men product's photos
  all('img[data-bb-look-fallback]').forEach(function (el) {
    var src = fallbackSrc('look');
    if (src) { el.src = src; el.removeAttribute('data-bb-look-fallback'); }
  });
  // Fit the zoom box to the image's real aspect ratio so hotspots + zoom land on the drawn photo
  (function () {
    var box = document.querySelector('[data-bb-look-box]'), stage = document.querySelector('[data-bb-look-stage]');
    if (!box || !stage) return;
    var img = box.querySelector('img');
    if (!img) return;
    var fitLook = function () {
      var iw = img.naturalWidth, ih = img.naturalHeight;
      if (!iw || !ih) return;
      box.style.aspectRatio = iw + ' / ' + ih;
      var r = stage.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var frac = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dImgW')) / 100 || .8;
      var wrap = box.closest('[data-bb-look-wrap]') || box.parentElement;
      if (wrap) wrap.style.width = Math.min(r.width * frac, r.height * (iw / ih)) + 'px';
    };
    img.addEventListener('load', fitLook);
    window.addEventListener('resize', fitLook);
    if (img.complete && img.naturalWidth) fitLook();
  })();
  all('[data-bb-look-thumb]').forEach(function (el) {
    if (!el.hasAttribute('data-bb-look-empty')) return;
    var src = fallbackSrc('look');
    if (!src) return;
    var d = DETAILS[(+el.getAttribute('data-bb-look-thumb')) | 0];
    el.style.backgroundImage = 'url(' + src + ')';
    el.style.backgroundPosition = d ? d.x + '% ' + d.y + '%' : '50% 50%';
    el.style.backgroundSize = '360% auto';
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundColor = '#fff';
  });

  function render() {
    var v = compute(state);
    styleBinds.forEach(function (b) {
      for (var prop in b.map) {
        var raw = b.map[prop];
        var val = typeof raw === 'string' ? raw.replace(/\[\[([\w.]+)\]\]/g, function (_, p) {
          var out = get(v, p);
          return out == null ? '' : String(out);
        }) : raw;
        if (b.last[prop] !== val) { b.el.style.setProperty(prop, val); b.last[prop] = val; }
      }
    });
    textBinds.forEach(function (b) { var t = String(get(v, b.p)); if (b.el.textContent !== t) b.el.textContent = t; });
    ifBinds.forEach(function (b) { b.el.hidden = !get(v, b.p); });
    // Keep the horizontally scrollable thumbnail strip in step with the active frame
    if (state.pd.i !== lastThumbIdx) {
      lastThumbIdx = state.pd.i;
      var sets = all('.bb-pdp-thumbs-scroll'), set = null;
      for (var si = 0; si < sets.length; si++) {
        var wrap = sets[si];
        if (!wrap.hidden && set === null) set = wrap;
      }
      if (set && set.scrollWidth > set.clientWidth) {
        var btn = set.querySelector('[data-bb-idx="' + lastThumbIdx + '"]');
        if (btn) {
          var br = btn.getBoundingClientRect(), cr = set.getBoundingClientRect();
          var target = set.scrollLeft + (br.left - cr.left) - (cr.width - br.width) / 2;
          set.scrollTo({ left: Math.max(0, Math.min(target, set.scrollWidth - set.clientWidth)), behavior: 'smooth' });
        }
      }
    }
    var paused = state.dHov || dPause > Date.now();
    var key = state.dIdx + (paused ? 'p' : '');
    if (key !== lastBarKey) {
      lastBarKey = key;
      bars.forEach(function (bar, k) {
        if (k !== state.dIdx) { bar.style.display = 'none'; return; }
        bar.style.display = 'block'; bar.style.animation = 'none'; void bar.offsetWidth;
        bar.style.animation = paused ? 'none' : 'bb-prog 3600ms linear forwards';
      });
    }
  }
  function set(patch) { for (var k in patch) { state[k] = patch[k]; } render(); }
  function upd(patch) {
    var pd = {}, k;
    for (k in state.pd) { pd[k] = state.pd[k]; }
    for (k in patch) { pd[k] = patch[k]; }
    set({ pd: pd });
  }
  function pickDetail(k) { dPause = Date.now() + 9000; set({ dIdx: state.dIdx === k ? -1 : k }); }

  function playTape() {
    clearTimeout(w1); clearTimeout(w2);
    if (state.tape !== 'idle') { set({ tape: 'idle' }); return; }
    set({ tape: 'loading' });
    w1 = setTimeout(function () {
      set({ tape: 'glitch' });
      w2 = setTimeout(function () { set({ tape: 'done' }); }, rm ? 300 : 1800);
    }, rm ? 0 : 1400);
  }

  function addToCart() {
    if (!prodOf(state.pd.g)) return;
    var sizes = sizesOf(state.pd.g);
    var sv = state.pd.sz >= 0 ? sizes[state.pd.sz] : null;
    if (!sv || !sv.id) { upd({ err: true }); return; }
    upd({ err: false });
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: sv.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { upd({ err: true }); return null; }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var count = cart.item_count != null ? cart.item_count : state.pd.n + 1;
          upd({ n: count, flash: true, err: false });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          setTimeout(function () { upd({ flash: false }); }, 2200);
        });
      })
      .catch(function () { upd({ err: true }); });
  }

  function handle(path) {
    var parts = path.split('.'), name = parts[0], k = +parts[1], el, w, r, arr;
    switch (name) {
      case 'pdThumbs':
        arr = imgsOf(state.pd.g);
        if (k >= 0 && k < arr.length) upd({ i: k });
        break;
      case 'pdPrev':
        dPause = Date.now() + 9000;
        upd({ i: (state.pd.i - 1 + imgsOf(state.pd.g).length) % imgsOf(state.pd.g).length });
        break;
      case 'pdNext':
        dPause = Date.now() + 9000;
        upd({ i: (state.pd.i + 1) % imgsOf(state.pd.g).length });
        break;
      case 'pdGenders':
        upd({ g: ['Men', 'Women'][k], sz: -1, zId: null, i: 0, flash: false, err: false });
        break;
      case 'pdSizes':
        arr = sizesOf(state.pd.g);
        if (k >= 0 && k < arr.length) upd({ sz: k, zId: arr[k].id, err: false });
        break;
      case 'pdAdd':
        addToCart();
        break;
      case 'dTabs': case 'dSpots':
        if (k >= 0 && k < DETAILS.length) pickDetail(k);
        break;
      case 'rcRows':
        el = document.querySelector('[data-remix-ch="' + k + '"]');
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
        break;
      case 'rcTabs':
        w = document.getElementById('rc-wrap'); if (!w) break;
        r = w.getBoundingClientRect();
        window.scrollTo({ top: r.top + window.scrollY + (r.height - window.innerHeight) * (k + .5) / 3, behavior: 'smooth' });
        break;
      case 'playTape':
        playTape();
        break;
      case 'faqs':
        set({ faq: state.faq === k ? -1 : k });
        break;
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-on-click]');
    if (!t) return;
    if (t.getAttribute('data-soldout') === '1') return;
    handle(t.getAttribute('data-on-click'));
  });
  all('[data-on-mouseenter]').forEach(function (el) { el.addEventListener('mouseenter', function () { set({ dHov: true }); }); });
  all('[data-on-mouseleave]').forEach(function (el) { el.addEventListener('mouseleave', function () { set({ dHov: false }); }); });

  // Running timecode and blinking REC dots
  setInterval(function () { set({ tc: state.tc + 1 }); }, 1000);
  // "Look closer" viewer: auto-tour through the detail points
  setInterval(function () { if (state.dHov || dPause > Date.now()) return; set({ dIdx: state.dIdx >= DETAILS.length - 1 ? -1 : state.dIdx + 1 }); }, 3600);

  // Remix Generation: active chapter follows scroll
  function rcScroll() {
    var k = 0, w, r, total;
    if (state.mob) {
      w = document.getElementById('rc-wrap'); if (!w) return;
      r = w.getBoundingClientRect(); total = Math.max(1, r.height - window.innerHeight);
      k = Math.floor(Math.min(.999, Math.max(0, -r.top / total)) * 3);
    } else {
      var line = window.innerHeight * 0.45;
      all('[data-remix-ch]').forEach(function (el, i) { if (el.getBoundingClientRect().top <= line) k = i; });
    }
    if (k !== state.rc) set({ rc: k });
  }
  window.addEventListener('scroll', rcScroll, { passive: true });
  window.addEventListener('resize', function () { headroom(); rcScroll(); });
  var onMq = function () { set({ mob: mqMob.matches }); rcScroll(); };
  if (mqMob.addEventListener) mqMob.addEventListener('change', onMq); else mqMob.addListener(onMq);

  // Sticky add-to-cart bar appears once the hero buttons scroll away
  var heroCta = document.getElementById('bba-hero-cta');
  if (heroCta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (on !== state.sticky) set({ sticky: on });
    }).observe(heroCta);
  }

  render();
  rcScroll();

  // Camcorder screen (canvas)
  (function () {
    var cv = document.getElementById('cam-canvas');
    if (!cv) return;
    var rmCam = rm;
    var ctx = cv.getContext('2d');
    var off = document.createElement('canvas'); off.width = 160; off.height = 120;
    var octx = off.getContext('2d'), nimg = octx.createImageData(160, 120);
    var W = 0, H = 0, dpr = 1, raf, to, last = state.tape, since = performance.now();
    var start = since;
    var size = function () { var r = cv.getBoundingClientRect(); var d = Math.min(2, window.devicePixelRatio || 1); var w = Math.round(r.width * d), h = Math.round(r.height * d); if (w === cv.width && h === cv.height) return; dpr = d; W = r.width; H = r.height; cv.width = w; cv.height = h; };
    size();
    window.addEventListener('resize', size);
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tc = function (s) { return Math.floor(s / 3600) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(Math.floor(s) % 60) + ':' + pad(Math.floor((s % 1) * 25)); };
    var txt = function (s, x, y, px, align, col, split) {
      ctx.font = (px * .62) + 'px Silkscreen, monospace'; ctx.textAlign = align || 'left'; ctx.textBaseline = 'middle';
      if (split) {
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(255,40,40,.85)'; ctx.fillText(s, x - split, y);
        ctx.fillStyle = 'rgba(40,255,90,.85)'; ctx.fillText(s, x, y + split * .3);
        ctx.fillStyle = 'rgba(60,110,255,.95)'; ctx.fillText(s, x + split, y);
        ctx.globalCompositeOperation = 'source-over';
      } else { ctx.fillStyle = col || '#fff'; ctx.fillText(s, x, y); }
    };
    var rr = function (x, y, w, hh, r) { ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(x, y, w, hh, r); else ctx.rect(x, y, w, hh); };
    var noise = function (alpha, blueBias) {
      var d = nimg.data;
      for (var i = 0; i < d.length; i += 4) {
        var v = Math.random() * 255 | 0;
        if (blueBias && Math.random() < blueBias) { d[i] = 93; d[i + 1] = 135; d[i + 2] = 153; }
        else { d[i] = d[i + 1] = d[i + 2] = v; }
        d[i + 3] = 255;
      }
      octx.putImageData(nimg, 0, 0);
      ctx.save(); ctx.globalAlpha = alpha; ctx.imageSmoothingEnabled = false; ctx.drawImage(off, 0, 0, W, H); ctx.restore();
    };
    var cassette = function (cx, cy, w, ang, u) {
      var bw = w * .9, bh = bw * .63, x = cx - bw / 2, y = cy - bh / 2, rr = bw * .05;
      ctx.save();
      ctx.strokeStyle = '#fff'; ctx.lineWidth = Math.max(1.5, u * .5);
      var rect = function (x0, y0, ww, hh, rad) {
        ctx.beginPath(); ctx.moveTo(x0 + rad, y0);
        ctx.arcTo(x0 + ww, y0, x0 + ww, y0 + hh, rad); ctx.arcTo(x0 + ww, y0 + hh, x0, y0 + hh, rad);
        ctx.arcTo(x0, y0 + hh, x0, y0, rad); ctx.arcTo(x0, y0, x0 + ww, y0, rad); ctx.closePath(); ctx.stroke();
      };
      rect(x, y, bw, bh, rr);
      rect(x + bw * .08, y + bh * .1, bw * .84, bh * .56, rr * .6);
      rect(x + bw * .24, y + bh * .26, bw * .52, bh * .26, bh * .13);
      var ry = y + bh * .39, rad = bh * .1;
      [x + bw * .35, x + bw * .65].forEach(function (rx) {
        ctx.beginPath(); ctx.arc(rx, ry, rad, 0, Math.PI * 2); ctx.stroke();
        for (var k = 0; k < 3; k++) {
          var a = ang + k * Math.PI * 2 / 3;
          ctx.beginPath(); ctx.moveTo(rx + Math.cos(a) * rad * .35, ry + Math.sin(a) * rad * .35);
          ctx.lineTo(rx + Math.cos(a) * rad * .85, ry + Math.sin(a) * rad * .85); ctx.stroke();
        }
      });
      ctx.beginPath(); ctx.moveTo(x + bw * .26, y + bh); ctx.lineTo(x + bw * .31, y + bh * .8); ctx.lineTo(x + bw * .69, y + bh * .8); ctx.lineTo(x + bw * .74, y + bh); ctx.stroke();
      ctx.restore();
    };
    var frame = function (now) {
      var m = state.tape;
      if (m !== last) { last = m; since = now; }
      var e = (now - since) / 1000, T = (now - start) / 1000;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var u = Math.min(W, H) / 100, mg = 6 * u;
      var playing = m === 'glitch' || m === 'done';
      if (m === 'idle' || m === 'loading') {
        ctx.fillStyle = '#5572a1'; ctx.fillRect(0, 0, W, H);
        var gr = ctx.createLinearGradient(0, 0, 0, H); gr.addColorStop(0, 'rgba(255,255,255,.14)'); gr.addColorStop(1, 'rgba(0,0,0,.22)');
        ctx.fillStyle = gr; ctx.fillRect(0, 0, W, H);
        if (m === 'idle') {
          var bob = rmCam ? 0 : Math.sin(T * 1.4) * u * .8;
          cassette(W / 2, H / 2 - 6 * u + bob, 40 * u, 0, u);
          if (Math.floor(T * 1.6) % 2 === 0 || rmCam) txt('PRESS PLAY TO PREVIEW', W / 2, H / 2 + 20 * u, 7.5 * u, 'center');
        } else {
          var p = Math.min(1, e / 1.3);
          cassette(W / 2, H / 2 - 8 * u, 40 * u, e * 9, u);
          txt('CUEING UP' + '...'.slice(0, (Math.floor(e * 4) % 4)), W / 2, H / 2 + 16 * u, 7 * u, 'center');
          var bw = 46 * u, bx = W / 2 - bw / 2, by = H / 2 + 23 * u;
          ctx.strokeStyle = '#fff'; ctx.lineWidth = 1.5; ctx.strokeRect(bx, by, bw, 3 * u);
          var segs = 16, filled = Math.floor(p * segs);
          for (var k = 0; k < filled; k++) { ctx.fillStyle = '#fff'; ctx.fillRect(bx + 1.5 + k * (bw - 3) / segs, by + 1.5, (bw - 3) / segs - 1.5, 3 * u - 3); }
        }
      }
      if (m === 'glitch') {
        ctx.fillStyle = '#081324'; ctx.fillRect(0, 0, W, H);
        var cols = 16, rows = 12, bw = W / cols, bh = H / rows, pal = ['#6d9eeb', '#38527d', '#c27ba0', '#e3e8ef', '#081324', '#b5c5df'];
        var dens = Math.max(.15, 1 - e * .45);
        for (var y = 0; y < rows; y++) {
          for (var x = 0; x < cols; x++) {
            if (Math.random() > dens) continue;
            ctx.fillStyle = pal[(Math.random() * pal.length) | 0];
            ctx.fillRect(x * bw, y * bh, Math.ceil(bw), Math.ceil(bh));
          }
        }
        for (var k2 = 0; k2 < 3; k2++) {
          var yl = ((Math.random() * rows) | 0) * bh;
          ctx.drawImage(cv, 0, yl * dpr, W * dpr, bh * dpr, (Math.random() - .5) * 8 * bw, yl, W, bh);
        }
        txt('FINDING THE FOOTAGE', W / 2, H / 2, 5.5 * u, 'center', null, .8 * u);
      }
      if (m === 'done') {
        ctx.fillStyle = '#05060a'; ctx.fillRect(0, 0, W, H);
        noise(.07, 0);
        var kick = Math.random() < .05 && !rmCam ? 3 * u : 0;
        var sp = .5 * u + kick + (e < .5 ? (1 - e * 2) * 4 * u : 0);
        txt('YOUR TAPE \u00b7 NO. ???', W / 2, H / 2 - 20 * u, 6.5 * u, 'center', 'rgba(255,255,255,.7)');
        txt('NOBODY HAS', W / 2, H / 2 - 5 * u, 12.5 * u, 'center', null, sp);
        txt('SEEN THIS', W / 2, H / 2 + 8 * u, 12.5 * u, 'center', null, sp);
        txt('IT ONLY PLAYS IN DELHI + BENGALURU', W / 2, H / 2 + 23 * u, 5.5 * u, 'center', 'rgba(255,255,255,.65)');
      }
      ctx.fillStyle = 'rgba(255,255,255,.06)';
      ctx.globalAlpha = .35;
      for (var yv = 0; yv < H; yv += 3) ctx.fillRect(0, yv, W, .5); for (var xv = 0; xv < W; xv += 3) ctx.fillRect(xv, 0, .5, H);
      ctx.globalAlpha = 1;
      var vg = ctx.createRadialGradient(W / 2, H / 2, Math.min(W, H) * .35, W / 2, H / 2, Math.max(W, H) * .75);
      vg.addColorStop(0, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(0,0,0,.45)');
      ctx.fillStyle = vg; ctx.fillRect(0, 0, W, H);
      ctx.strokeStyle = 'rgba(255,255,255,.9)'; ctx.lineWidth = 1.5;
      var L = 7 * u, b = mg * .7;
      [[b, b, 1, 1], [W - b, b, -1, 1], [b, H - b, 1, -1], [W - b, H - b, -1, -1]].forEach(function (c) {
        ctx.beginPath(); ctx.moveTo(c[0], c[1] + c[3] * L); ctx.lineTo(c[0], c[1]); ctx.lineTo(c[0] + c[2] * L, c[1]); ctx.stroke();
      });
      if (playing) {
        var fs = 9 * u + (rmCam ? 0 : Math.sin(T * 3) * .6 * u);
        [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(function (cxy) {
          var x = W / 2 + cxy[0] * fs, y = H / 2 + cxy[1] * fs * .75;
          ctx.beginPath(); ctx.moveTo(x, y - cxy[1] * 2.5 * u); ctx.lineTo(x, y); ctx.lineTo(x - cxy[0] * 2.5 * u, y); ctx.stroke();
        });
      } else {
        ctx.beginPath(); ctx.moveTo(W / 2 - 2 * u, H * .14); ctx.lineTo(W / 2 + 2 * u, H * .14); ctx.moveTo(W / 2, H * .14 - 2 * u); ctx.lineTo(W / 2, H * .14 + 2 * u); ctx.stroke();
      }
      var hp = 6.5 * u, top = mg + 2 * u;
      var label = m === 'idle' ? 'STBY' : m === 'loading' ? 'LOAD' : 'PLAY';
      var lx = mg + 2 * u;
      if (playing) {
        ctx.save(); ctx.fillStyle = '#fff'; ctx.beginPath();
        ctx.moveTo(lx, top - 2 * u); ctx.lineTo(lx + 3.6 * u, top); ctx.lineTo(lx, top + 2 * u); ctx.closePath(); ctx.fill(); ctx.restore();
        lx += 5 * u;
      }
      txt(label, lx, top, hp, 'left');
      if (playing && Math.floor(T * 2) % 2 === 0) {
        ctx.fillStyle = '#fff'; ctx.beginPath();
        ctx.arc(lx + ctx.measureText(label).width + 4 * u, top, 1.4 * u, 0, Math.PI * 2); ctx.fill();
      }
      txt('DV', W - mg - 15 * u, top, hp, 'right');
      var bx2 = W - mg - 12 * u, bw2 = 10 * u, bh2 = 4.4 * u;
      ctx.strokeRect(bx2, top - bh2 / 2, bw2, bh2); ctx.fillStyle = '#fff'; ctx.fillRect(bx2 + bw2, top - bh2 / 4, u * .8, bh2 / 2);
      var lvl = playing ? 3 : 4;
      for (var k3 = 0; k3 < lvl; k3++) ctx.fillRect(bx2 + 1 * u + k3 * 2.2 * u, top - bh2 / 2 + 1 * u, 1.6 * u, bh2 - 2 * u);
      var bot = H - mg - 2 * u;
      txt(playing ? tc(e + (m === 'done' ? 1.8 : 0)) : '0:00:00:00', mg + 2 * u, bot, hp, 'left');
      txt('OCT 16 2026', W - mg - 2 * u, bot, hp, 'right');
      var zx = W - mg - 1 * u, zy0 = H * .3, zy1 = H * .7;
      ctx.strokeStyle = 'rgba(255,255,255,.75)'; ctx.beginPath(); ctx.moveTo(zx, zy0); ctx.lineTo(zx, zy1); ctx.stroke();
      txt('T', zx, zy0 - 3.5 * u, 5 * u, 'center', 'rgba(255,255,255,.75)'); txt('W', zx, zy1 + 3.5 * u, 5 * u, 'center', 'rgba(255,255,255,.75)');
      var zp = playing ? .5 + Math.sin(T * .7) * .3 : (m === 'loading' ? 1 - Math.min(1, e / 1.3) * .6 : .85);
      ctx.fillStyle = '#fff'; ctx.fillRect(zx - 1.8 * u, zy0 + (zy1 - zy0) * zp - .6 * u, 3.6 * u, 1.2 * u);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      if (rmCam) to = setTimeout(function () { raf = requestAnimationFrame(frame); }, 500);
      else raf = requestAnimationFrame(frame);
    };
    raf = requestAnimationFrame(frame);
  })();
})();